import {z} from 'zod';
import dedent from 'dedent';
import {defineToolRegistryManifest} from '../../../types/base-tool-types';
import {brokenLinkSchema} from '../audit-page-links/audit-page-links';

const toolName = 'seo-audit-site-links' as const;

export const auditSiteLinksArgsSchema = z.object({
  siteId: z.string().describe('The ID of the site to audit'),
});

export type AuditSiteLinksArgs = z.infer<typeof auditSiteLinksArgsSchema>;

export const auditSiteLinksResultSchema = z.object({
  siteId: z.string(),
  pagesAudited: z.number(),
  totalLinksChecked: z.number(),
  brokenLinks: z.array(brokenLinkSchema),
  errors: z.array(z.string()),
});

export type AuditSiteLinksResult = z.infer<typeof auditSiteLinksResultSchema>;

export const auditSiteLinksManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Audit site links',
  prettyStatus: {
    executed: 'Audited site for broken links',
    executing: 'Auditing site for broken links',
    failed: 'Failed to audit site links',
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Audits all pages on a site for broken internal links. Scans each page's DOM
      nodes for link elements pointing to deleted, archived, or unpublished pages.
      Calls audit-page-links for each page.
    `,
    inputSchema: auditSiteLinksArgsSchema,
  },
  type: 'server',
  permission: [{resource: 'SiteLink', action: 'manage'}],
  confirmBeforeExecuting: false,
  timeout: 600000,
});
